module.exports = __webpack_public_path__ + "static/bizum_monei-aefc1f9b278315742794a7b1ae0a05a1.svg";